import WidgetClassRegisterRequestRequestModelBase from '../_generated/modelBases/widget-class-register-request-request-model-base';

export default class WidgetClassRegisterRequestRequestModel extends WidgetClassRegisterRequestRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
